import { withRouter } from 'react-router-dom';
import IconButton from '@material-ui/core/IconButton';
import ProjectLanguageSelector from '../../core/ProjectLanguageSelector';
import TitledPanel from '../../core/TitledPanel';
import GS from '../../grafsync/grafsync';
import SearchSelect from '../../core/SearchSelect';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { withStyles } from '@material-ui/core/styles';
import Tooltip from '@material-ui/core/Tooltip';
import Typography from '@material-ui/core/Typography';
import PropTypes from 'prop-types';
import React from 'react';
import CancelButton from '../../core/CancelButton';
import { ProjectConsumer } from '../../core/providers/ProjectProvider';
import { globalStyles } from '../../core/style/gstheme';
import DeleteIcon from '@material-ui/icons/Delete';
import { APPLICATION_PATHS } from '../../application-core/constants';

const styles = theme => {
    return Object.assign({
        deprecated: {
            color: '#CA4F0C',
            fontSize: 10,
            display: 'block'
        },
    }, globalStyles);
};

class ManageRelatedConceptDialog extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            lang: props.defaultLang,
            shown: [],
            text: ""
        };
    }

    updateSearchText = (text) => this.setState({ text });

    handleDelete = (iri) => {
        if (this.props.existingValues.includes(iri)) {
            GS.deleteProperty(this.props.source, this.props.graph, this.props.property, iri);
        }
    };

    computeSearch = (value, lang, projectIRI, skosXL) => {
        const property = this.props.property;
        let fullSearch =
        {
            search: [
                {
                    predicate: "http://www.w3.org/2004/02/skos/core#" + property,
                    value: this.props.source,
                    reverse: true
                },
                {
                    predicate: "http://www.w3.org/2004/02/skos/core#prefLabel",
                    value: value,
                    isExactMatch: false
                },
                {
                    predicate: "http://www.w3.org/1999/02/22-rdf-syntax-ns#type",
                    value: "http://www.w3.org/2004/02/skos/core#Concept"
                }
            ],
            graph: [this.props.graph],
            pageSize: 20,
            entailment: skosXL ? ["propertyChain"] : [],
            language: lang,
            predicates: [
                "http://www.w3.org/2004/02/skos/core#prefLabel",
                "http://www.w3.org/2002/07/owl#deprecated",
                "https://grafsync.graphifi.com/schema/gs/iri",
                "https://grafsync.graphifi.com/schema/gs/status",
                "http://www.w3.org/2004/02/skos/core#inScheme"
            ]
        };
        return fullSearch;
    };

    includeConcept = (id) => {
        this.props.onIncludeConcept(id);
        this.exitFindConcept();
    };

    changeLanguage = (lang) => this.setState({ lang });

    showConcept = (iri) => {
        if (this.props.showConcept) {
            if (!this.state.shown.includes(iri)) {
                this.setState({ shown: [...this.state.shown, iri] });
            }
            this.props.showConcept(iri);
            return;
        }
        const link = APPLICATION_PATHS.TAXONOMY_MANAGER + '/project/taxonomy#project=' +
            this.props.projectIRI + "&taxonomy=" + this.props.schemeIRI + "&view=concept&concept=" + iri;
        this.props.history.push(link);
    };

    render() {

        const { classes, addTitle, exclude, hideOnRemoved, exitSearchConcept, isReadOnly, existingValues, projectIRI } = this.props;
        const { text, lang, shown } = this.state;

        return (
            <ProjectConsumer>
                {({ skosXL }) => (
                    <Dialog
                        data-test="search-concept-dialog"
                        fullWidth
                        maxWidth="lg"
                        classes={{
                            paper: classes.paper,
                            paperWidthLg: classes.largeDialog
                        }}
                        className={classes.dialog}
                        open={true}
                        onClose={exitSearchConcept}
                        aria-labelledby="search-concept-dialog-title">
                        <DialogTitle disableTypography className={classes.mainHeading} id="search-concept-dialog-title">{addTitle || "Manage Relationships"}</DialogTitle>
                        <DialogContent style={{ height: 450 }}>
                            <TitledPanel title="Language">
                                <ProjectLanguageSelector dataTest="relationship-language" includeLabel={false} onSelect={this.changeLanguage} />
                            </TitledPanel>
                            <div style={{ height: 350 }}>
                                <SearchSelect
                                    key={lang}
                                    dataTest="search-concept"
                                    focus={true}
                                    exclude={[...exclude, ...shown]}
                                    updateSearchText={this.updateSearchText}
                                    sortByLength={true}
                                    allowEmpty={false}
                                    initialText={text}
                                    maxLength={250}
                                    search={(value, lang) => this.computeSearch(value, lang, projectIRI, skosXL)}
                                    isClickableResult={(result) => !hideOnRemoved || existingValues.includes(result.id)}
                                    listSecondIcon={(result) =>
                                        !existingValues.includes(result.id) ?
                                            <Typography data-test="removed" variant="caption">Removed</Typography>
                                            :
                                            !isReadOnly && existingValues.includes(result.id) ?
                                                <Tooltip title="Delete relationship">
                                                    <IconButton
                                                        aria-label="Delete relationship"
                                                        onClick={(event) => {
                                                            event.preventDefault();
                                                            event.stopPropagation();
                                                            this.handleDelete(result.id);
                                                        }}
                                                        size="small">
                                                        <DeleteIcon
                                                            data-test="delete-relationship"
                                                            fontSize="small"
                                                        />
                                                    </IconButton>
                                                </Tooltip>
                                                :
                                                null
                                    }
                                    listSelectionDisplay={(result, lang) => result.prefLabel && result.prefLabel[lang] ?
                                        Array.isArray(result.prefLabel[lang]) ?
                                            result.prefLabel[lang][0]
                                            :
                                            result.prefLabel[lang]
                                        :
                                        ""}
                                    listDisplay={(result, lang) => {
                                        const text = result.prefLabel && result.prefLabel[lang] ?
                                            Array.isArray(result.prefLabel[lang]) ?
                                                result.prefLabel[lang].sort().join(" AND ")
                                                :
                                                result.prefLabel[lang]
                                            :
                                            result.id;
                                        const currentIRI = result.iri && result.iri.length > 0 ?
                                            result.iri[result.iri.length - 1]
                                            :
                                            result.id;
                                        return <div>
                                            <Typography
                                                data-test="result-text"
                                                lang={lang}
                                                variant="body2">
                                                <span style={{ wordBreak: 'break-word' }}>
                                                    <Tooltip
                                                        PopperProps={{
                                                            "data-test": "result-tip"
                                                        }}
                                                        title={currentIRI}>
                                                        <span data-test="result-text-words">{text}</span>
                                                    </Tooltip>
                                                </span>
                                            </Typography>
                                            {result.deprecated && <span data-test="slat-deprecated" className={classes.deprecated}>Deprecated</span>}
                                        </div>;
                                    }}
                                    sortProp="prefLabel"
                                    title="Find a concept"
                                    lang={lang}
                                    chosen={this.showConcept} />
                            </div>
                        </DialogContent>
                        <DialogActions className={classes.dialogActions}>
                            <CancelButton onClick={exitSearchConcept} >Close</CancelButton>
                        </DialogActions>
                    </Dialog>
                )}
            </ProjectConsumer>
        );
    }
}

ManageRelatedConceptDialog.defaultProps = {
    isReadOnly: false,
    hideOnRemoved: false,
    exclude: []
};

ManageRelatedConceptDialog.propTypes = {
    classes: PropTypes.object,
    addTitle: PropTypes.string,
    schemeIRI: PropTypes.string.isRequired,
    property: PropTypes.string.isRequired,
    existingValues: PropTypes.array,
    isReadOnly: PropTypes.bool,
    showConcept: PropTypes.func,
    hideOnRemoved: PropTypes.bool,
    exitSearchConcept: PropTypes.func.isRequired,
    source: PropTypes.string,
    defaultLang: PropTypes.string.isRequired,
    projectIRI: PropTypes.string.isRequired,
    errorText: PropTypes.string,
    graph: PropTypes.string.isRequired
};

export default withRouter(withStyles(styles)(ManageRelatedConceptDialog));